import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import state from "./state.js";
import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";
import createPersistedState from "vuex-persistedstate";

let store = {
  state,
  mutations,
  actions,
  getters,
  // 这是把所有数据缓存到本地 也可以进行配置
  plugins: [
    // createPersistedState()
    createPersistedState({ storage: window.localStorage}),
  ],
};

export default new Vuex.Store(store);
